<template>
    <AppLayout
        ref="layout"
        :selectedPeople="selection"
        :hasFab="!!selection.length"
        :fabLoading="composeEmailLoading"
        page="/dashboard"
        pageTitle="Membership Prices"
        backLink="/dashboard/reports"
        @eventProgress="
            [(progress = $event.progress), (progressError = $event.error)]
        "
        @fabAction="selection.length ? emailUsers() : null"
    >
        <v-col cols="12" class="pa-1">
            <Stats class="pb-3" :stats="stats" />
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <ReportHeader
                        :dateSelection="false"
                        absolute
                        filter
                        reportUrl="/dashboard/reports/membership-prices/"
                        @search="[(search = $event), expand()]"
                    >
                        <template #filterItem>
                            <v-list dense>
                                <v-list-item>
                                    <v-btn
                                        :href="`${$page.url}?csv=true`"
                                        text
                                        outlined
                                        rounded
                                        block
                                        color="dark"
                                        >Download as CSV<v-icon small right
                                            >download</v-icon
                                        ></v-btn
                                    >
                                </v-list-item>
                            </v-list>
                        </template>
                    </ReportHeader>
                    <v-data-table
                        ref="table"
                        v-model="selection"
                        :headers="headers"
                        :items="membershipPrices"
                        :search="search"
                        show-select
                        groupBy="groupColumn"
                        groupDesc
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        :custom-sort="customSort"
                        @item-selected="handleItemSelect($event)"
                        @current-items="collapse()"
                        @toggle-select-all="expand($event)"
                        @click:row="$log($event.id)"
                    >
                        <!--<template
                            v-slot:[`header.data-table-select`]="{ items }"
                        >
                        </template>-->
                        <template
                            v-slot:[`group.header`]="{
                                group,
                                items,
                                isOpen,
                                toggle,
                            }"
                        >
                            <th colspan="1">
                                <tr>
                                    <v-row
                                        no-gutters
                                        class="align-center flex-nowrap"
                                    >
                                        <v-icon
                                            @click="
                                                [
                                                    toggle(),
                                                    isOpen
                                                        ? (selection =
                                                              selection.filter(
                                                                  (e) =>
                                                                      e.price_id !==
                                                                      group
                                                              ))
                                                        : null,
                                                ]
                                            "
                                            class="mr-3"
                                            >{{ isOpen ? "remove" : "add" }}
                                        </v-icon>
                                    </v-row>
                                </tr>
                            </th>
                            <th colspan="1">
                                <div
                                    class="soli-grey text-subtitle-2 font-weight-bold whitespace-nowrap"
                                >
                                    {{ items.length }} Membership(s)
                                </div>
                            </th>

                            <th colspan="1">
                                <tr>
                                    <div
                                        class="soli-grey text-subtitle-2 font-weight-bold whitespace-nowrap flex-nowrap flex"
                                    >
                                        {{ `${items[0].name}` }}
                                    </div>
                                </tr>
                            </th>
                            <th colspan="1">
                                <tr>
                                    <div
                                        class="soli-grey text-subtitle-2 font-weight-bold"
                                    >
                                        {{ items[0].format_amount }}
                                    </div>
                                </tr>
                            </th>
                            <th colspan="1"></th>
                            <th colspan="1">
                                <tr class="justify-end flex">
                                    <!--<v-menu left>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                icon
                                            >
                                                <v-icon>more_vert</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                >Update Pricing</v-list-item
                                            >
                                        </v-list>
                                    </v-menu>-->
                                    <v-btn
                                        small
                                        text
                                        rounded
                                        color="accent"
                                        @click="
                                            [
                                                isOpen ? null : toggle(),
                                                (selection = items),
                                            ]
                                        "
                                    >
                                        Select All
                                        <v-icon small right
                                            >check_box</v-icon
                                        ></v-btn
                                    >
                                    <v-btn
                                        small
                                        text
                                        color="error"
                                        rounded
                                        :disabled="
                                            !editable ||
                                            !uniquePriceIds.includes(group)
                                        "
                                        @click="handleEditPrice(group)"
                                        >Edit
                                        <v-icon small right>edit</v-icon></v-btn
                                    >
                                </tr>
                            </th>
                        </template>
                        <template v-slot:[`item.student.name`]="{ item }">
                            <div class="d-flex align-center py-2 soli-grey">
                                <v-list-item-avatar
                                    style="float: left"
                                    class="my-0"
                                >
                                    <v-img
                                        :src="
                                            item.student.profile_photo_path
                                                ? `/api/image-service/40x40/${item.student.profile_photo_path}`
                                                : item.student.profile_photo_url
                                        "
                                    ></v-img>
                                </v-list-item-avatar>
                                <div>
                                    <v-list-item-title>
                                        <Link
                                            :href="`/profile/${item.student.id}/account`"
                                        >
                                            {{ item.student.name }}
                                        </Link>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        <v-icon
                                            v-if="item.student.recipient"
                                            small
                                            color="secondary"
                                            >handshake</v-icon
                                        >
                                        {{ item.student.email }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        {{
                                            item.lesson ??
                                            "No Scheduled Lessons"
                                        }}</v-list-item-subtitle
                                    >
                                </div>
                            </div>
                        </template>

                        <template v-slot:[`item.name`]="{ item }"
                            ><div class="flex flex-nowrap whitespace-nowrap">
                                {{ item.name }}
                            </div>
                        </template>

                        <template v-slot:[`item.tags`]="{ item }">
                            <div class="flex gap-1">
                                <v-chip
                                    v-for="tag in item.tags"
                                    :key="tag.id"
                                    :color="tag.color"
                                    x-small
                                    class="white--text font-weight-bold text-capitalize"
                                    >{{ tag.name }}</v-chip
                                >
                            </div>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-col>
        <BatchUpdateMembershipPrice
            v-if="editPrice && selection.length"
            :membershipPrice="editPrice"
            :purchaseOptions="selection"
            :errors="errors"
            @reset="closeModal(() => (editPrice = null))"
            @success="
                [
                    ($refs.layout.showMessage = true),
                    (selection = []),
                    (loading = true),
                    (editPrice = null),
                ]
            "
        />
        <!--<SoliChoice
            v-if="editPrice && !selection.length"
            title="Uh Oh!"
            subtitle="Please make a selection"
            button1="Okay"
        />-->
        <SoliChoice
            v-if="loading && !progressError"
            :title="progress < 100 ? 'Updating Memberships' : 'Complete'"
            :subtitle="
                progress < 100
                    ? 'Processing Your Request'
                    : 'Memberships Updated Successfully!'
            "
            permanent
            :disabled1="progress < 100"
            :button1="progress < 100 ? 'Please Wait' : 'Close'"
            @reset="handleComplete()"
        >
            <div class="px-3 pb-3">
                <v-progress-linear
                    :buffer-value="progress"
                    stream
                    rounded
                    color="secondary"
                />
            </div>
        </SoliChoice>
        <SoliChoice
            v-if="progressError"
            title="Contact kyle@musicologie.com"
            :subtitle="`Something went wrong. ${progressError}`"
            button1="Close"
            warning
            @reset="handleComplete()"
        />
        <ComposeEmail
            v-if="composeEmail"
            :emails="selectedEmails"
            signature
            sendAsStudio
            tinyMCE
            :user="$page.props.auth.user"
            :errors="errors"
            @success="emailSuccess()"
            @reset="closeModal(() => (composeEmail = false))"
        />
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import globalMoment from "../../Mixins/GlobalMoment";
import ReportHeader from "../../Components/Reports/ReportHeader.vue";
import Stats from "../../Components/Reports/Stats.vue";
import BatchUpdateMembershipPrice from "../../Components/Reports/BatchUpdateMembershipPrice.vue";
import ComposeEmail from "../../Components/Users/ComposeEmail.vue";
import SoliChoice from "../../Components/Base/SoliChoice.vue";

export default {
    mixins: [globalMoment],
    props: {
        membershipPrices: {
            type: Array,
            default: () => [],
        },
        errors: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        AppLayout,
        Link,
        ReportHeader,
        Stats,
        BatchUpdateMembershipPrice,
        ComposeEmail,
    },
    data() {
        return {
            search: "",
            showMessage: false,
            selection: [],
            editPrice: null,
            composeEmail: false,
            selectedEmails: [],
            composeEmailLoading: false,
            loading: false,
            progress: 0,
            progressError: false,
            headers: [
                {
                    text: "Memberships",
                    align: "start",
                    sortable: false,
                    value: "student.name",
                },
                {
                    text: "Product",
                    align: "start",
                    sortable: false,
                    value: "name",
                },
                {
                    text: "Price",
                    align: "start",
                    sortable: false,
                    value: "format_amount",
                },
                {
                    text: "Tags",
                    align: "start",
                    sortable: false,
                    value: "tags",
                },
                {
                    text: "tagSearch",
                    align: "start",
                    sortable: false,
                    value: "tagSearch",
                    class: "hide",
                    cellClass: "hide",
                },
                {
                    text: "",
                    align: "start",
                    sortable: false,
                    value: "",
                },
            ],
        };
    },
    computed: {
        stats() {
            return [
                {
                    title: "Memberships",
                    data: this.membershipPrices.length,
                    color: "accent",
                    icon: "contacts",
                    hidden: false,
                },
                {
                    title: "Selected",
                    data: this.selection.length,
                    color: "secondary",
                    icon: "check_circle",
                    hidden: !this.selection.length,
                },
            ].filter((stat) => !stat.hidden);
        },
        uniquePriceIds() {
            return [...new Set(this.selection.map((e) => e.groupColumn))];
        },
        editable() {
            return this.uniquePriceIds.length == 1;
        },
    },
    methods: {
        handleItemSelect(item) {
            this.$nextTick(() => {
                /*this.selection = this.selection.filter(
                    (e) => e.price_id == item.item.price_id
                );*/
            });
        },
        handleEditPrice(groupId) {
            this.editPrice = this.membershipPrices.find(
                (e) => e.groupColumn == groupId
            );

            this.selection = this.selection.filter(
                (e) => e.groupColumn == groupId
            );
        },
        collapse(exception) {
            if (this.search.length) return;
            this.$nextTick(() => {
                let obj = this.$refs.table.openCache;
                Object.keys(obj).forEach((e) => {
                    if (e == exception) return;
                    obj[e] = false;
                });
                //this.selection = [];
            });
        },
        expand(event) {
            if (!event?.value && !this.search.length) return this.collapse();
            this.$nextTick(() => {
                let obj = this.$refs.table.openCache;
                Object.keys(obj).forEach((e) => {
                    obj[e] = true;
                });
            });
        },
        emailUsers() {
            if (!this.selection.length) return;
            this.composeEmailLoading = true;
            axios
                .get("/api/users/email", {
                    params: {
                        selectedPeople: this.selection.map((e) => e.student.id),
                        getStudents: 1,
                    },
                })
                .then((resp) => {
                    this.selectedEmails = resp.data;
                    this.composeEmail = true;
                    this.composeEmailLoading = false;
                });
        },
        emailSuccess() {
            this.$refs.appLayout.showMessage = true;
            this.closeModal(() => (this.composeEmail = false));
        },
        handleComplete() {
            this.loading = false;
            this.progress = 0;
            this.$inertia.reload();
        },
        customSort(items, index, isDesc) {
            return items
                .sort((a, b) => a.groupColumn - b.groupColumn)
                .sort((a, b) => a.unit_amount - b.unit_amount)
                .sort((a, b) => a.duration - b.duration);
            //.sort((a, b) => a.duration - b.duration)
            //.sort((a, b) => a.unit_amount - b.unit_amount);
            /*return items.sort((a, b) => {
                 return (a.price_id + a.unit_amount) - (b.price_id + b.unit_amount)
            });*/
        },
    },
};
</script>
